/**
 * Created by jonahkim on 4/13/16.
 */

(function () {
    'use strict';

    // @ngInject
    function BaseWSModelManagerCtor($q,
                                    WSAPIService, WSAPIRoutesService,
                                    ModelFactory) {
        this.APIService = WSAPIService;
        this.$q = $q;
        this.WSAPIRoutesService = WSAPIRoutesService;
        this.ModelFactory = ModelFactory;
    }

    Services.BaseWSModelManager = Class(Services.BaseModelManager, {

        constructor: BaseWSModelManagerCtor,

        apiFetch: function apiFetch(routeId, data, model, updateModelData, headers) {
            return this._wsRoutesThenApiCall(this.ACTION_FETCH, routeId, data, model, updateModelData, headers)
        },

        apiCreate: function apiCreate(routeId, data, model, updateModelData, headers) {
            return this._wsRoutesThenApiCall(this.ACTION_CREATE, routeId, data, headers, model, updateModelData);
        },

        apiUpdate: function apiUpdate(routeId, data, model, updateModelData, headers) {
            return this._wsRoutesThenApiCall(this.ACTION_UPDATE, routeId, data, headers, model, updateModelData);
        },

        apiDelete: function apiDelete(routeId, data, model, updateModelData, headers) {
            return this._wsRoutesThenApiCall(this.ACTION_DELETE, routeId, data, headers, model, updateModelData);
        },

        apiFetchCollection: function apiFetchCollection(routeId, data, collection, updateCollectionData, headers, saveToCache) {
            return this._wsRoutesThenCollectionApiCall(this.ACTION_FETCH, routeId, data, collection, updateCollectionData, headers, saveToCache);
        },

        _wsRoutesThenApiCall: function (action, routeId, data, model, updateModelData, headers){

            var defer = this.$q.defer();

            this.WSAPIRoutesService.getRoutes().then(

                function success(routes){
                    if (routeId in routes){
                        var url = routes[routeId];

                        if ('_id' in data && data['_id']) {
                            url += data['_id'] + '/';
                            delete data['_id'];
                        }

                        this._apiCall(action, url, data, headers, model, updateModelData).then(
                            defer.resolve,
                            defer.reject
                        )
                    } else {
                        defer.reject({
                            data: {},
                            status: 200,
                            statusText: 'No route with ID: ' + routeId,
                            model: null,
                        });
                    }
                }.bind(this),

                function error(resp){
                    defer.reject(resp);
                });

            return defer.promise;
        },

        _wsRoutesThenCollectionApiCall: function(action, routeId, data, model, updateModelData, headers){

            var defer = this.$q.defer();

            this.WSAPIRoutesService.getRoutes().then(

                function success(routes){
                    if (routeId in routes) {
                        var url = routes[routeId];
                        this._collectionApiCall(action, url, data, headers, model, updateModelData).then(
                            defer.resolve,
                            defer.reject
                        )
                    } else {
                        defer.reject({
                            data: {},
                            status: 200,
                            statusText: 'No route with ID: ' + routeId,
                            model: null,
                        });
                    }
                }.bind(this),

                function error(resp){
                    defer.reject(resp);
                });

            return defer.promise;
        },

        _collectionApiCall: function _collectionApiCall(action, url, data, headers, collection, updateCollectionData, saveToCache) {

            var self = this;

            var deferred = this.$q.defer();

            collection.onCollectionUpdating();

            this.APIService[action](url, data, headers).then(
                function success(resp) {

                    var content = resp.data;
                    var isFirstPage = !content.previous;
                    var isComplete = !content.next;

                    deferred.resolve({
                        data: content.results,
                        status: resp.status,
                        headers: resp.headers,
                        collection: collection
                    });

                    if (updateCollectionData) {
                        self._receivedCollectionDataFromServer(collection, content.results, resp.status, isFirstPage, isComplete, saveToCache);
                    }

                    if (content.next) {
                        if (data.page){
                            data.page = data.page + 1;
                        } else {
                            data.page = 2;
                        }
                        self._collectionApiCall(action, url, data, headers, collection, updateCollectionData, saveToCache);
                    }

                },

                function error(resp) {

                    var shouldStopEvents = false;

                    if(!shouldStopEvents){
                        deferred.reject({
                            data: resp.data,
                            status: resp.status,
                            statusText: resp.statusText,
                            collection: collection
                        });

                        if (collection) {
                            collection.onCollectionError(resp.data, resp.status);
                        }
                    }
                }
            );

            return deferred.promise;
        },

        _receivedCollectionDataFromServer: function _receivedCollectionDataFromServer(collection, collectionData, responseStatus, isFirstPage, isComplete, saveToCache) {
            var keepExistingRecords = !isFirstPage;
            collection.mixinFrom(collectionData, undefined, saveToCache, true, keepExistingRecords, isComplete);
            collection.onCollectionSuccess("data fetched", responseStatus);

            if (isComplete) {
                collection.onPagingEnded();
            }
        }
    });
}());
